import { useCallback } from 'react';
import { useSetCalendarSyncMutation } from 'shared/hooks/queries/use-set-calendar-sync-mutation';
import { SetCalendarSyncInput } from 'shared/services/backend-api';

export const useSetCalendarSync = () => {
  const { mutate } = useSetCalendarSyncMutation();

  return useCallback((input: SetCalendarSyncInput) => mutate(input), [mutate]);
};
